export default __webpack_public_path__ + "static/media/Full Device.94a824d1.png";